import React from 'react'
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next'

const CustomRender = ({ value, variant }) => {
    const { t } = useTranslation();
    return <Typography variant={variant} data-testid={value}>{t(value)}</Typography>;
}

export default CustomRender